<template>
  <div class="content full">
    <e-breadcrumbs />
    <win-layer-pop class="sample_popup_list">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <h1 class="page_title">{{ $t('cp.CTRL060P010.001') }}</h1>
    <div class="content_box mt10" id="frmReq">
      <table class="tbl_search">
        <colgroup>
          <col width="100px">
          <col>
          <col width="100px">
          <col>
          <col width="100px">
          <col>
          <col width="100px">
        </colgroup>
        <tbody>
          <tr>
            <th>{{ $t('cp.CTRL060P010.002') }}</th>
            <td class="cp-relative">
              <input
                :id="`yearWeekPsel`"
                class="cp-psel"
                @mousedown.stop="clickPsel('yearWeek')"
                :placeholder="setPselTxt('yearWeek')"
                readonly
              >
              <div
                :id="`yearWeekPopt`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': yearWeekList?.length === 0,
                      'cp-pchkbox--selected': send.keyInput.yearWeek?.length !== 0 && (yearWeekList.length === send.keyInput.yearWeek.length)
                    }"
                    @click.prevent="controlPchk('yearWeek')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`yearWeekPoptSearch`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="yearWeekList?.length === 0">
                </div>
                <ul v-if="yearWeekList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText('yearWeek') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in yearWeekList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': send.keyInput.yearWeek.includes(item.yearWeek),
                      'cp-li--hide': searchPopt(item.yearWeek, item.yearWeek)
                    }"
                    @click.prevent="clickPopt('yearWeek', item.yearWeek)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': send.keyInput.yearWeek.includes(item.yearWeek)}"><span class="offscreen">No</span></label>
                    <span>{{ item.yearWeek }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P010.003') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.porCtr" @change="getHarborList(param.porCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.porPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P010.004') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.dlyCtr" @change="getHarborList2(param.dlyCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.dlyPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList2" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <td class="text_right">
              <a class="button blue sh" href="#" @click.prevent="select">{{ $t('cp.COMMON.001') }}</a>
            </td>
          </tr>
          <tr>
            <th>{{ $t('cp.CTRL060P010.005') }}</th>
            <td>
              <div class="tbl_form cp-relative">
                <a href="#" @click.prevent="openPopup('CstSearchListPop', 'bkgShipper')" class="button sm cp-td-button">
                  <template v-if="param.bkgShipLength === 0 || param.bkgShipLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="param.bkgShipLength === 1">
                    <span class="cp-short-text">{{ param.lastBkgShip }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ param.bkgShipLength }}) {{ param.lastBkgShip }}</span>
                  </template>
                </a>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P010.008') }}</th>
            <td>
              <input type="text" v-model="param.salEnt">
            </td>
            <th>{{ $t('cp.CTRL060P010.009') }}</th>
            <td>
              <input type="text" v-model="param.salUno">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab">
      <ul>
        <li class="on" id="tab1" @click="selectTab(1)"><a href="javascript:void(0)">{{ $t('cp.CTRL060P010.073') }}</a></li>
        <li id="tab2" @click="selectTab(2)"><a href="javascript:void(0)">{{ $t('cp.CTRL060P010.074') }}</a></li>
      </ul>
    </div>
    <div class="content_box" v-show="tapState === 1">
      <div id="realgrid" class="mt5" style="width: 100%; height: 750px" />
    </div>
    <div class="content_box" v-show="tapState === 2">
      <div id="realgrid2" class="mt5" style="width: 100%; height: 750px" />
    </div>
  </div>
</template>

  <script>
  import { createGrid } from '@/plugins/realgridUtil'
  import { rootComputed } from '@/store/helpers'
  import bsaTotalData from '@/api/rest/bsa/bsaTotalData'
  import bsaCommonInfo from '@/api/rest/bsa/bsaCommonInfo'
  import EBreadcrumbs from '@/components/common/EBreadcrumbs'
  import JSZip from 'jszip'

  window.JSZip = window.JSZip || JSZip
  let gridView = null
  let provider = null
  let gridView2 = null
  let provider2 = null

  const fields = [
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'bkgShprCstNo', dataType: 'text' },
    { fieldName: 'actShprCstNo', dataType: 'text' },
    { fieldName: 'cmdtCd', dataType: 'text' },
    { fieldName: 'salEnt', dataType: 'text' },
    { fieldName: 'salUno', dataType: 'text' },
    { fieldName: 'cstPicNo', dataType: 'text' },
    { fieldName: 'cntrFrtAmt', dataType: 'number' },
    { fieldName: 'cm1Amt', dataType: 'number' },
    { fieldName: 'lstLdgDt', dataType: 'text' },
    { fieldName: 'avgLdgCyc', dataType: 'number' },
    { fieldName: 'mdLdgCyc', dataType: 'number' },
    { fieldName: 'prfSun', dataType: 'number' },
    { fieldName: 'prfMon', dataType: 'number' },
    { fieldName: 'prfTue', dataType: 'number' },
    { fieldName: 'prfWed', dataType: 'number' },
    { fieldName: 'prfThu', dataType: 'number' },
    { fieldName: 'prfFri', dataType: 'number' },
    { fieldName: 'prfSat', dataType: 'number' },
    { fieldName: 'avgEarTeu', dataType: 'number' },
    { fieldName: 'avgMidTeu', dataType: 'number' },
    { fieldName: 'avgEndTeu', dataType: 'number' },
    { fieldName: 'avgTt', dataType: 'number' },
    { fieldName: 'prfPorTmlCd', dataType: 'text' },
    { fieldName: 'prfPorTmlRat', dataType: 'number' },
    { fieldName: 'prfDlyTmlCd', dataType: 'text' },
    { fieldName: 'prfDlyTmlRat', dataType: 'number' },
    { fieldName: 'sfCorCmb', dataType: 'text' },
    { fieldName: 'sfCorTeuRat', dataType: 'number' },
    { fieldName: 'spcoCorCmb', dataType: 'text' },
    { fieldName: 'spcoCorTeuRat', dataType: 'number' },
    { fieldName: 'teuWgtVal', dataType: 'text' },
    { fieldName: 'fiCorCmb', dataType: 'text' },
    { fieldName: 'fiCorFrtRat', dataType: 'text' },
    { fieldName: 'expTeu', dataType: 'number' },
    { fieldName: 'expFrtAmt', dataType: 'number' },
    { fieldName: 'expCm1Amt', dataType: 'number' },
    { fieldName: 'wvExpTeu', dataType: 'number' },
    { fieldName: 'wvExpFrtAmt', dataType: 'number' },
    { fieldName: 'wvExpCm1Amt', dataType: 'number' },
    { fieldName: 'expWgtPerTeu', dataType: 'number' },
    { fieldName: 'expVslCd', dataType: 'text' },
    { fieldName: 'expVoyNo', dataType: 'text' },
    { fieldName: 'expRteCd', dataType: 'text' },
    { fieldName: 'avgCntrFrtAmt', dataType: 'number' },
    { fieldName: 'avgCm1Amt', dataType: 'number' }
  ]
  const columns = [
    { name: 'yearWeek', fieldName: 'yearWeek', header: { text: app.$t('cp.CTRL060P010.002') }, editable: false, width: 60, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P010.003') }, editable: false, width: 40 },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P010.004') }, editable: false, width: 40 },
    { name: 'bkgShprCstNo', fieldName: 'bkgShprCstNo', header: { text: app.$t('cp.CTRL060P010.005') }, editable: false, width: 80, renderer: { showTooltip: true } },
    { name: 'actShprCstNo', fieldName: 'actShprCstNo', header: { text: app.$t('cp.CTRL060P010.006') }, editable: false, width: 80, renderer: { showTooltip: true } },
    { name: 'cmdtCd', fieldName: 'cmdtCd', header: { text: app.$t('cp.CTRL060P010.007') }, editable: false, width: 50 },
    { name: 'salEnt', fieldName: 'salEnt', header: { text: app.$t('cp.CTRL060P010.008') }, editable: false, width: 60 },
    { name: 'salUno', fieldName: 'salUno', header: { text: app.$t('cp.CTRL060P010.009') }, editable: false, width: 80 },
    { name: 'cstPicNo', fieldName: 'cstPicNo', header: { text: app.$t('cp.CTRL060P010.010') }, editable: false, width: 80 },
    { name: 'cntrFrtAmt', fieldName: 'cntrFrtAmt', header: { text: app.$t('cp.CTRL060P010.011') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'cm1Amt', fieldName: 'cm1Amt', header: { text: app.$t('cp.CTRL060P010.012') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'lstLdgDt', fieldName: 'lstLdgDt', header: { text: app.$t('cp.CTRL060P010.013') }, editable: false, width: 90 },
    { name: 'avgLdgCyc', fieldName: 'avgLdgCyc', header: { text: app.$t('cp.CTRL060P010.014') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'mdLdgCyc', fieldName: 'mdLdgCyc', header: { text: app.$t('cp.CTRL060P010.015') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfSun', fieldName: 'prfSun', header: { text: app.$t('cp.CTRL060P010.020') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfMon', fieldName: 'prfMon', header: { text: app.$t('cp.CTRL060P010.021') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfTue', fieldName: 'prfTue', header: { text: app.$t('cp.CTRL060P010.022') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfWed', fieldName: 'prfWed', header: { text: app.$t('cp.CTRL060P010.023') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfThu', fieldName: 'prfThu', header: { text: app.$t('cp.CTRL060P010.024') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfFri', fieldName: 'prfFri', header: { text: app.$t('cp.CTRL060P010.025') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfSat', fieldName: 'prfSat', header: { text: app.$t('cp.CTRL060P010.026') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgEarTeu', fieldName: 'avgEarTeu', header: { text: app.$t('cp.CTRL060P010.028') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgMidTeu', fieldName: 'avgMidTeu', header: { text: app.$t('cp.CTRL060P010.029') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgEndTeu', fieldName: 'avgEndTeu', header: { text: app.$t('cp.CTRL060P010.030') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgTt', fieldName: 'avgTt', header: { text: app.$t('cp.CTRL060P010.031') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfPorTmlCd', fieldName: 'prfPorTmlCd', header: { text: app.$t('cp.CTRL060P010.034') }, editable: false, width: 60 },
    { name: 'prfPorTmlRat', fieldName: 'prfPorTmlRat', header: { text: app.$t('cp.CTRL060P010.035') }, numberFormat: '#,##0.###', editable: false, width: 60, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'prfDlyTmlCd', fieldName: 'prfDlyTmlCd', header: { text: app.$t('cp.CTRL060P010.034') }, editable: false, width: 60 },
    { name: 'prfDlyTmlRat', fieldName: 'prfDlyTmlRat', header: { text: app.$t('cp.CTRL060P010.035') }, numberFormat: '#,##0.###', editable: false, width: 60, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'sfCorCmb', fieldName: 'sfCorCmb', header: { text: app.$t('cp.CTRL060P010.036'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'sfCorTeuRat', fieldName: 'sfCorTeuRat', header: { text: app.$t('cp.CTRL060P010.037'), styleName: 'multi-line-css' }, numberFormat: '#,##0.###', editable: false, width: 125, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'spcoCorCmb', fieldName: 'spcoCorCmb', header: { text: app.$t('cp.CTRL060P010.038'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'spcoCorTeuRat', fieldName: 'spcoCorTeuRat', header: { text: app.$t('cp.CTRL060P010.039'), styleName: 'multi-line-css' }, numberFormat: '#,##0.###', editable: false, width: 125, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'teuWgtVal', fieldName: 'teuWgtVal', header: { text: app.$t('cp.CTRL060P010.040'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'fiCorCmb', fieldName: 'fiCorCmb', header: { text: app.$t('cp.CTRL060P010.041'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'fiCorFrtRat', fieldName: 'fiCorFrtRat', header: { text: app.$t('cp.CTRL060P010.042'), styleName: 'multi-line-css' }, editable: false, width: 127, styleName: 'text_left' },
    { name: 'expTeu', fieldName: 'expTeu', header: { text: app.$t('cp.CTRL060P010.045') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expFrtAmt', fieldName: 'expFrtAmt', header: { text: app.$t('cp.CTRL060P010.046') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expCm1Amt', fieldName: 'expCm1Amt', header: { text: app.$t('cp.CTRL060P010.047') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpTeu', fieldName: 'wvExpTeu', header: { text: app.$t('cp.CTRL060P010.045') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpFrtAmt', fieldName: 'wvExpFrtAmt', header: { text: app.$t('cp.CTRL060P010.046') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpCm1Amt', fieldName: 'wvExpCm1Amt', header: { text: app.$t('cp.CTRL060P010.047') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expWgtPerTeu', fieldName: 'expWgtPerTeu', header: { text: app.$t('cp.CTRL060P010.048') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expRteCd', fieldName: 'expRteCd', header: { text: app.$t('cp.CTRL060P010.016') }, editable: false, width: 100 },
    { name: 'expVslCd', fieldName: 'expVslCd', header: { text: app.$t('cp.CTRL060P010.017') }, editable: false, width: 100 },
    { name: 'expVoyNo', fieldName: 'expVoyNo', header: { text: app.$t('cp.CTRL060P010.018') }, editable: false, width: 100 },
    { name: 'avgCntrFrtAmt', fieldName: 'avgCntrFrtAmt', header: { text: app.$t('cp.CTRL060P010.049') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgCm1Amt', fieldName: 'avgCm1Amt', header: { text: app.$t('cp.CTRL060P010.050') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } }
  ]

  const layout = [
    {
      name: 'group0',
      header: { visible: false },
      direction: 'horizontal',
      items: [{ column: 'yearWeek', footerUserSpans: [{ colspan: 3 }] },
          'porPlcCd',
          'dlyPlcCd'
      ]
    },
    'bkgShprCstNo',
    'actShprCstNo',
    'cmdtCd',
    'salEnt',
    'salUno',
    'cstPicNo',
    'cntrFrtAmt',
    'cm1Amt',
    'lstLdgDt',
    'avgLdgCyc',
    'mdLdgCyc',
    {
      name: app.$t('cp.CTRL060P010.019'),
      items: [
        { column: 'prfSun' },
        { column: 'prfMon' },
        { column: 'prfTue' },
        { column: 'prfWed' },
        { column: 'prfThu' },
        { column: 'prfFri' },
        { column: 'prfSat' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P010.027'),
      items: [
        { column: 'avgEarTeu' },
        { column: 'avgMidTeu' },
        { column: 'avgEndTeu' }
      ]
    },
    'avgTt',
    {
      name: app.$t('cp.CTRL060P010.032'),
      items: [
        { column: 'prfPorTmlCd' },
        { column: 'prfPorTmlRat' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P010.033'),
      items: [
        { column: 'prfDlyTmlCd' },
        { column: 'prfDlyTmlRat' }
      ]
    },
    'sfCorCmb',
    'sfCorTeuRat',
    'spcoCorCmb',
    'spcoCorTeuRat',
    'teuWgtVal',
    'fiCorCmb',
    'fiCorFrtRat',
    {
      name: app.$t('cp.CTRL060P010.043'),
      items: [
        { column: 'expTeu' },
        { column: 'expFrtAmt' },
        { column: 'expCm1Amt' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P010.044'),
      items: [
        { column: 'wvExpTeu' },
        { column: 'wvExpFrtAmt' },
        { column: 'wvExpCm1Amt' }
      ]
    },
    'expWgtPerTeu',
    'expRteCd',
    'expVslCd',
    'expVoyNo',
    'avgCntrFrtAmt',
    'avgCm1Amt'
  ]

  const fields2 = [
    { fieldName: 'yearWeek', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'cntrFrtAmt', dataType: 'number' },
    { fieldName: 'cm1Amt', dataType: 'number' },
    { fieldName: 'lstLdgDt', dataType: 'text' },
    { fieldName: 'avgEarTeu', dataType: 'number' },
    { fieldName: 'avgMidTeu', dataType: 'number' },
    { fieldName: 'avgEndTeu', dataType: 'number' },
    { fieldName: 'avgTt', dataType: 'number' },
    { fieldName: 'sfCorCmb', dataType: 'text' },
    { fieldName: 'sfCorTeuRat', dataType: 'number' },
    { fieldName: 'spcoCorCmb', dataType: 'text' },
    { fieldName: 'spcoCorTeuRat', dataType: 'number' },
    { fieldName: 'teuWgtVal', dataType: 'text' },
    { fieldName: 'fiCorCmb', dataType: 'text' },
    { fieldName: 'fiCorFrtRat', dataType: 'text' },
    { fieldName: 'expTeu', dataType: 'number' },
    { fieldName: 'expFrtAmt', dataType: 'number' },
    { fieldName: 'expCm1Amt', dataType: 'number' },
    { fieldName: 'wvExpTeu', dataType: 'number' },
    { fieldName: 'wvExpFrtAmt', dataType: 'number' },
    { fieldName: 'wvExpCm1Amt', dataType: 'number' },
    { fieldName: 'expWgtPerTeu', dataType: 'number' },
    { fieldName: 'expVslCd', dataType: 'text' },
    { fieldName: 'expVoyNo', dataType: 'text' },
    { fieldName: 'expRteCd', dataType: 'text' },
    { fieldName: 'avgCntrFrtAmt', dataType: 'number' },
    { fieldName: 'avgCm1Amt', dataType: 'number' }
  ]
  const columns2 = [
    { name: 'yearWeek', fieldName: 'yearWeek', header: { text: app.$t('cp.CTRL060P010.002') }, editable: false, width: 60, footer: { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' } },
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P010.003') }, editable: false, width: 40 },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P010.004') }, editable: false, width: 40 },
    { name: 'cntrFrtAmt', fieldName: 'cntrFrtAmt', header: { text: app.$t('cp.CTRL060P010.011') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'cm1Amt', fieldName: 'cm1Amt', header: { text: app.$t('cp.CTRL060P010.012') }, numberFormat: '#,##0.###', editable: false, width: 70, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgEarTeu', fieldName: 'avgEarTeu', header: { text: app.$t('cp.CTRL060P010.028') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgMidTeu', fieldName: 'avgMidTeu', header: { text: app.$t('cp.CTRL060P010.029') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgEndTeu', fieldName: 'avgEndTeu', header: { text: app.$t('cp.CTRL060P010.030') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgTt', fieldName: 'avgTt', header: { text: app.$t('cp.CTRL060P010.031') }, numberFormat: '#,##0.###', editable: false, width: 50, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'sfCorCmb', fieldName: 'sfCorCmb', header: { text: app.$t('cp.CTRL060P010.036'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'sfCorTeuRat', fieldName: 'sfCorTeuRat', header: { text: app.$t('cp.CTRL060P010.037'), styleName: 'multi-line-css' }, numberFormat: '#,##0.###', editable: false, width: 125, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'spcoCorCmb', fieldName: 'spcoCorCmb', header: { text: app.$t('cp.CTRL060P010.038'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'spcoCorTeuRat', fieldName: 'spcoCorTeuRat', header: { text: app.$t('cp.CTRL060P010.039'), styleName: 'multi-line-css' }, numberFormat: '#,##0.###', editable: false, width: 125, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'teuWgtVal', fieldName: 'teuWgtVal', header: { text: app.$t('cp.CTRL060P010.040'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'fiCorCmb', fieldName: 'fiCorCmb', header: { text: app.$t('cp.CTRL060P010.041'), styleName: 'multi-line-css' }, editable: false, width: 125, styleName: 'text_left' },
    { name: 'fiCorFrtRat', fieldName: 'fiCorFrtRat', header: { text: app.$t('cp.CTRL060P010.042'), styleName: 'multi-line-css' }, editable: false, width: 127, styleName: 'text_left' },
    { name: 'expTeu', fieldName: 'expTeu', header: { text: app.$t('cp.CTRL060P010.045') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expFrtAmt', fieldName: 'expFrtAmt', header: { text: app.$t('cp.CTRL060P010.046') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expCm1Amt', fieldName: 'expCm1Amt', header: { text: app.$t('cp.CTRL060P010.047') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpTeu', fieldName: 'wvExpTeu', header: { text: app.$t('cp.CTRL060P010.045') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpFrtAmt', fieldName: 'wvExpFrtAmt', header: { text: app.$t('cp.CTRL060P010.046') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'wvExpCm1Amt', fieldName: 'wvExpCm1Amt', header: { text: app.$t('cp.CTRL060P010.047') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expWgtPerTeu', fieldName: 'expWgtPerTeu', header: { text: app.$t('cp.CTRL060P010.048') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'expRteCd', fieldName: 'expRteCd', header: { text: app.$t('cp.CTRL060P010.016') }, editable: false, width: 100 },
    { name: 'expVslCd', fieldName: 'expVslCd', header: { text: app.$t('cp.CTRL060P010.017') }, editable: false, width: 100 },
    { name: 'expVoyNo', fieldName: 'expVoyNo', header: { text: app.$t('cp.CTRL060P010.018') }, editable: false, width: 100 },
    { name: 'avgCntrFrtAmt', fieldName: 'avgCntrFrtAmt', header: { text: app.$t('cp.CTRL060P010.049') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'avgCm1Amt', fieldName: 'avgCm1Amt', header: { text: app.$t('cp.CTRL060P010.050') }, numberFormat: '#,##0.###', editable: false, width: 100, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } }
  ]

  const layout2 = [
    {
      name: 'group0',
      header: { visible: false },
      direction: 'horizontal',
      items: [{ column: 'yearWeek', footerUserSpans: [{ colspan: 3 }] },
          'porPlcCd',
          'dlyPlcCd'
      ]
    },
    'cntrFrtAmt',
    'cm1Amt',
    {
      name: app.$t('cp.CTRL060P010.027'),
      items: [
        { column: 'avgEarTeu' },
        { column: 'avgMidTeu' },
        { column: 'avgEndTeu' }
      ]
    },
    'avgTt',
    'sfCorCmb',
    'sfCorTeuRat',
    'spcoCorCmb',
    'spcoCorTeuRat',
    'teuWgtVal',
    'fiCorCmb',
    'fiCorFrtRat',
    {
      name: app.$t('cp.CTRL060P010.043'),
      items: [
        { column: 'expTeu' },
        { column: 'expFrtAmt' },
        { column: 'expCm1Amt' }
      ]
    },
    {
      name: app.$t('cp.CTRL060P010.044'),
      items: [
        { column: 'wvExpTeu' },
        { column: 'wvExpFrtAmt' },
        { column: 'wvExpCm1Amt' }
      ]
    },
    'expWgtPerTeu',
    'expRteCd',
    'expVslCd',
    'expVoyNo',
    'avgCntrFrtAmt',
    'avgCm1Amt'
  ]

  export default {
    name: 'BsaTotalData',
    components: {
      EBreadcrumbs,
      WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
      EDatePicker: () => import('@/components/common/EDatePicker'),
      EWeekRangePicker: () => import('@/components/common/EWeekRangePicker'),
      CstSearchListPop: () => import('@/pages/cp/popup/CstSearchListPop')
    },
    data: function () {
      return {
        customComponent: null,
        parentInfo: {
          position: '',
          ships: [],
          bkgShipper: []
        },
        list: [{}],
        param: {
          yearWeek: '',
          etdDtFr: '',
          etdDtTo: '',
          porCtr: '',
          porPlc: '',
          dlyCtr: '',
          dlyPlc: '',
          salEnt: '',
          salUno: '',
          bkgShipper: '',
          bkgShipperList: [],
          bkgShipLength: 0,
          lastBkgShip: ''
        },
        countryList: [],
        countryList2: [],
        harborList: [],
        harborList2: [],
        yearWeekList: [],
        yearWeekSearchList: [],
        poptSearchKeyword: '',
        currentYearWeek: '',
        tapState: 1,
        send: {
          keyInput: {
            yearWeek: []
          }
        }
      }
    },
    computed: {
      ...rootComputed
    },
    created () {
      for (const type of ['mousedown', 'click']) {
        window.addEventListener(type, this.cpCustomEvent)
      }

      const arrMonthInfo = this.$ekmtcCommon.getDefaultStEnDt({ startCode: '', startGap: 0, endCode: 'W', endGap: 4 })

      this.currentYearWeek = moment(arrMonthInfo.enDt).format('YYYYWW')
    },
    mounted: function () {
      const $vm = this
      window.func = this
      const grid = createGrid('realgrid', {
        fields,
        columns,
        layout,
        header: { heights: [45, 45] },
        displayOptions: {
          rowHeight: 28,
          fitStyle: 'none',
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 28 } },
        options: { summaryMode: 'aggregate' },
        fixedOptions: { colCount: 6 },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView = grid.gridView
      provider = grid.provider

      gridView.onShowTooltip = function (grid, idx, value) {
        const columns = ['bkgShprCstEnm', 'actShprCstEnm', 'userName']
        if (columns.includes(idx.column)) {
          let breakLine = ''
          let oneLine = ''
          let oneLineByteLength = 0

          for (const token of value) {
            oneLine += token

            // 한글과 한글 외 텍스트의 너비 계산
            const unicode = token.charCodeAt(0)
            if (unicode > 127 || (unicode > 64 && unicode < 91)) {
              oneLineByteLength += 2
            } else {
              oneLineByteLength += 1
            }

            // 조건에 따른 개행
            if (token === '\n' || (token === ' ' && oneLineByteLength > 70)) {
              breakLine += oneLine + (token === '\n' ? '' : ' \n')
              oneLine = ''
              oneLineByteLength = 0
            }
          }
          breakLine += oneLine
          return breakLine
        }
      }

      const grid2 = createGrid('realgrid2', {
        fields: fields2,
        columns: columns2,
        layout: layout2,
        header: { heights: [45, 45] },
        displayOptions: {
          rowHeight: 28,
          fitStyle: 'none',
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: { height: 28 } },
        options: { summaryMode: 'aggregate' },
        fixedOptions: { colCount: 1 },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView2 = grid2.gridView
      provider2 = grid2.provider

      $vm.getCountryList()
      $vm.getYearWeekList()
    },
    methods: {
      openAlert: function (msg) {
        let obj = {
          alertType: 'simple',
          onClose: this.closeFun,
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$t('cp.COMMON.005'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
      },
      cpCustomEvent (e) {
        const type = e.type

        switch (type) {
          case 'mousedown': {
            // click anywhere
            this.controlPopt()
            break
          }
          case 'dbclick': {
            break
          }
        }
      },
      getCountryList: function () {
        bsaCommonInfo.countryList().then(response => {
          this.countryList = response.data
          this.countryList2 = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList = response.data
          this.param.porPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList2: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList2 = response.data
          this.param.dlyPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      async getYearWeekList () {
        await bsaCommonInfo.yearWeekList().then(response => {
          this.yearWeekList = response.data
          if (this.yearWeekList.map(row => row.yearWeek).includes(this.currentYearWeek)) {
            this.send.keyInput.yearWeek.push(this.currentYearWeek)
          } else {
            this.send.keyInput.yearWeek.push(String(Math.max(...this.yearWeekList.map(row => row.yearWeek))))
          }
        }).catch(err => {
          console.log(err)
        })
      },
      select: function () {
        if (this.send.keyInput.yearWeek.length > 0) {
          this.param.yearWeek = this.send.keyInput.yearWeek.join(',')
        } else {
          this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL060P010.072'), () => {
            return false
          })
        }

        if (this.tapState === 1) {
          bsaTotalData.list(this.param).then(response => {
            this.list = response.data
            if (this.list.length > 0) {
              provider.setRows(this.list)
              gridView.setCurrent({ itemIndex: 0 })
            } else {
              this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G140.044'), () => {
                return false
              })
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          bsaTotalData.sectionlist(this.param).then(response => {
            this.list = response.data
            if (this.list.length > 0) {
              provider2.setRows(this.list)
              gridView2.setCurrent({ itemIndex: 0 })
            } else {
              this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G140.044'), () => {
                return false
              })
            }
          }).catch(err => {
            console.log(err)
          })
        }
      },
      // 'Booking Shipper' 자동완성 change event
      cstChange (vo) {
        this.pod = vo
        this.param.bkgShprCstEnm = vo.cdNm
        this.param.bkgShprCstNo = vo.cd
        const frm = document.querySelector('#frmReq')
        const elem = frm.querySelector('#bkgCst')
        this.$ekmtcCommon.hideErrorTooltip(elem)
      },
      readonlyItemchk: function ($e) {
        if (!this.isExistResult) {
          $e.target.checked = true
        }
      },
      convertFormatPeriod: function (periodFr, periodTo, defaultText) {
        if (this.isExistResult) {
          return `${periodFr.replace(/(\d{4})(\d{1,2}(?=\d{2})|\d{1,2}(?=\d{1}))(\d{1,2}).*/, '$1.$2.$3')} ~\n   ${periodTo.replace(/(\d{4})(\d{1,2}(?=\d{2})|\d{1,2}(?=\d{1}))(\d{1,2}).*/, '$1.$2.$3')}`
        } else {
          return defaultText
        }
      },
      convertFormatNum: function (num, type) {
        if (num === null || num === undefined || num === '') {
          return ''
        } else {
          const intAdjust = Number.isInteger(num) ? '.0' : ''
          const perSign = type === 'rate' ? ' %' : ''
          return num.toLocaleString() + intAdjust + perSign
        }
      },
      sortItemOrder: function (item) {
        if (this.isExistResult) {
          this.itemOrder.splice(this.itemOrder.indexOf(item), 1)
          this.itemOrder.push(item)
          const checkedList = this.itemOrder.filter((elem) => this.itemInfo[elem].checked === true)
          const uncheckedList = this.itemOrder.filter((elem) => this.itemInfo[elem].checked === false)
          this.itemOrder = [...checkedList, ...uncheckedList]

          const sortedLayout = ['bkgShprCstEnm', 'actShprCstEnm', 'por', 'dly', 'item']
          for (const item of this.itemOrder) {
            sortedLayout.push(layout2.slice(2).filter(obj => obj.name === item)[0])
          }
          gridView2.setColumnLayout(sortedLayout)

          for (const elem of Object.entries(this.itemInfo)) {
            const [item, info] = elem
            if (info.checked) {
              gridView2.layoutByName(item).visible = true
            } else {
              gridView2.layoutByName(item).visible = false
            }
          }

          if (checkedList.length !== 0) {
            gridView2.setVisible(true)
          } else {
            gridView2.setVisible(false)
          }
        }
      },
      async openPopup (compNm, position) {
        if (this.customComponent !== null) {
          this.customComponent = null
          this.$ekmtcCommon.layerClose()
        }

        this.parentInfo.position = position
        if (position === 'bkgShipper') {
          this.parentInfo.ships = this.param.bkgShipperList
        }

        this.customComponent = compNm
        this.position = position
        this.confirmChk = 'Y'
        this.$ekmtcCommon.layerOpen('.sample_popup_list')
      },
      closePopup (obj) {
        if (obj === undefined || obj === '' || obj === null) {
          this.customComponent = null
          this.$ekmtcCommon.layerClose('.sample_popup_list')
          return
        }

        switch (true) {
          case this.position === 'bkgShipper': {
            this.param.bkgShipper = obj.shipper.join(',')
            this.param.bkgShipperList = obj.shipper
            this.param.bkgShipLength = obj.shipLength
            this.param.lastBkgShip = obj.lastShip

            break
          }
        }

        this.customComponent = null
        this.$ekmtcCommon.layerClose('.sample_popup_list')
      },
      clickPsel (type) {
      const popt = document.querySelector(`#${type}Popt`)
      const poptSearch = document.querySelector(`#${type}PoptSearch`)

      if (poptSearch) {
        setTimeout(() => {
          poptSearch.focus()
        }, 50)
      }

      this.controlPopt(popt)
      },
      controlPopt (targetPopt) {
        this.poptSearchKeyword = ''

        const poptList = document.querySelectorAll('.cp-popt')
        for (const popt of poptList) {
          if (popt !== targetPopt && !popt.classList.contains('cp-popt--close')) {
            popt.classList.add('cp-popt--close')
          }
        }

        if (targetPopt) {
          targetPopt.classList.toggle('cp-popt--close')

          const poptUl = targetPopt.querySelector('ul:last-child')
          for (const poptLi of poptUl.children) {
            if (poptLi.classList.contains('cp-li--selected')) {
              poptUl.scrollTop = (poptLi.offsetTop)
              break
            }
          }
        }
      },
      async clickPopt (type, value) {
        switch (true) {
          case type.includes('yearWeek'): {
            const targetList = this.send.keyInput[type]

            if (!targetList.includes(value)) {
              targetList.push(value)
            } else {
              targetList.splice(targetList.indexOf(value), 1)
            }

            break
          }
        }
      },
      controlPchk (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.yearWeekList
            const yearWeekSearchList = this.yearWeekSearchList
            var cnt = 0

            if (this.send.keyInput[type].length === yearWeekList.length) {
              if (this.send.keyInput[type].length === yearWeekSearchList.length) {
                this.send.keyInput[type] = []
              } else {
                for (const i of this.yearWeekSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              }
            } else {
              for (const i of yearWeekSearchList) {
                if (this.send.keyInput[type].includes(i)) {
                  cnt = cnt + 1
                }
              }

              if (cnt > 0 && cnt === yearWeekSearchList.length) {
                for (const i of this.yearWeekSearchList) {
                  if (this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].splice(this.send.keyInput[type].indexOf(i), 1)
                  }
                }
              } else {
                for (const i of yearWeekSearchList) {
                  if (!this.send.keyInput[type].includes(i)) {
                    this.send.keyInput[type].push(i)
                  }
                }
              }
            }

            break
          }
        }
      },
      setLongestText (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.yearWeekList
            const yearWeekLengthList = yearWeekList.map(row => row.yearWeek.length)
            if (yearWeekList?.length === 0) {
              return 0
            } else {
              const longestYearWeekLength = Math.max(...yearWeekLengthList)
              const longestYearWeekIdx = yearWeekLengthList.indexOf(longestYearWeekLength)
              const longestYearWeek = yearWeekList[longestYearWeekIdx].yearWeek

              return longestYearWeek
            }
          }
        }
      },
      setPselTxt (type) {
        switch (true) {
          case type.includes('yearWeek'): {
            const yearWeekList = this.send.keyInput[type]

            if (yearWeekList?.length >= 1) {
              if (yearWeekList.length > 1) {
                return `(${yearWeekList.length}) ${yearWeekList.at(-1)}`
              } else {
                return yearWeekList[0]
              }
            } else {
              return this.$t('cp.COMMON.002')
            }
          }
        }
      },
      searchPopt (orgName, orgCode) {
        const keyword = this.poptSearchKeyword.toLowerCase()
        const name = orgName.toLowerCase()
        const code = orgCode.toLowerCase()

        const isHide = !(
          keyword === name.substr(0, keyword.length) ||
          keyword === code.substr(0, keyword.length)
        )

        if (!this.yearWeekSearchList.includes(name)) {
          if (isHide === false) {
            this.yearWeekSearchList.push(name)
          }
        } else {
          if (isHide === true) {
            this.yearWeekSearchList.splice(this.yearWeekSearchList.indexOf(name), 1)
          }
        }

        return isHide
      },
      selectTab (tab) {
        $('.tab li').removeClass('on')

        $('#tab' + tab).addClass('on')

        this.tapState = tab
      }
    }
  }
  </script>
  <style>
    /* sr : Scenario Result */
    .srtabmenu {
      table-layout: fixed;
    }

    .srtabmenu {
      border: 1px solid #e1e3eb !important;
    }

    .srtabmenu th {
      text-align: center;
    }

    .srtabmenu_itemchk td {
      text-align: center;
    }

    .srgraph_container {
      display: flex;
      padding: 10px;
      border: 1px solid #e1e3eb;
      gap: 10px;
    }

    .srgraph_content {
      width: 70%;
    }

    .srgraph_dashboard {
      display: flex;
      flex-wrap: wrap;
      height: inherit;
      gap: 10px;
    }

    .srgraph_unit {
      flex-basis: calc(33.33% - 6.7px);
      display: flex;
      height: 170px;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    .srgraph_unittitle {
      position: relative;
      width: 100%;
      height: 33px;
      border-top: 1px solid #e1e3eb;
      border-bottom: 1px solid #e1e3eb;
      background-color: #f6f9ff;
      color: #075bb9;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }

    .srgraph_unitrow {
      display: grid;
      position: relative;
      width: 100%;
      height: 30px;
      box-sizing: border-box;
    }

    .srgraph_valA,
    .srgraph_valB {
      grid-template-columns: 2fr 1.5fr 6.5fr;
    }

    .srgraph_rate {
      grid-template-columns: 2fr 4fr 4fr;
    }

    .srgraph_leftbar {
      display: flex;
      position: relative;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }

    .srgraph_baseline {
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 27px;
      background-color: #e2e2e2;
    }

    .srgraph_basevalue {
      position: absolute;
      right: -11px;
      bottom: -17px;
      color: #777777;
      font-size: 12px;
    }

    .srgraph_rightbar {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
    }

    .srgraph_axistitle {
      font-size: 14px;
      line-height: 30px;
    }

    .srgraph_bar {
      width: 0px;
      height: 20px;
      opacity: 1;
      transition: width 0.5s ease-in, opacity 0.2s ease-out;
    }

    .srgraph_highlightbar {
      opacity: 0.7;
    }

    .srgraph_bar:hover {
      opacity: 0.7;
    }

    .srgraph_normalL {
      max-width: 20px;
    }
    .srgraph_normalR {
      max-width: 169px;
    }

    .srgraph_negative,
    .srgraph_positive {
      max-width: 67px;
    }

    .srgraph_normalL {
      background-color: #888888;
    }

    .srgraph_normalR {
      background-color: #888888;
    }

    .srgraph_negative {
      background-color: #0083df;
    }

    .srgraph_positive {
      background-color: #dc584e;
    }

    .srgraph_stats {
      width: 30%;
    }

    .srgraph_statshead,
    .srgraph_statsrow {
      display: grid;
      grid-template-columns: 1fr 1.1fr 1.1fr 0.8fr;
    }

    .srgraph_statshead {
      height: 66px;
      border-top: 1px solid #e1e3eb;
      border-bottom: 1px solid #e1e3eb;
      background: #f6f9ff;
      color: #075bb9;
      font-weight: 500;
      text-align: center;
    }

    .srgraph_statshead div:not(.srgraph_statshead div:first-child) {
      border-left: 1px solid #e1e3eb;
    }

    .srgraph_statsbody {
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 66px);
    }

    .srgraph_statsrow {
      text-align: center;
      flex-basis: 100%;
      border-bottom: 1px solid #e1e3eb;
    }

    .srgraph_statsvalue {
      display: flex;
      padding: 10px;
      border-left: 1px solid #e1e3eb;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }

    .srgraph_statsname {
      padding-left: 5px;
      border-left: 0;
      background: #f6f9ff;
      color: #075bb9;
      font-weight: 500;
    }

    .srgraph_newline {
      white-space: pre;
    }

    .srgrid_hidden,
    .srgraph_hidden {
      display: none;
    }

    .srgraph_cleartag {
      visibility: hidden;
    }

    .srgraph_emptyvalue::after {
      content: '-';
    }

    .srgraph_centertext {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .excelTitle {
      font-size: 18px;
      font-weight: bold;
    }

    .cp-td-button {
    width: 100%;
    height: 24px !important;
    text-align: left;
    box-sizing: border-box;
    padding: 0 5px !important;
    color: #000000 !important;
    border: solid 1px #cecece !important;
    border-radius: 0px !important;
    background: url('data:image/png;base64,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') no-repeat center right;
  }

  .cp-td-button.disabled {
    border: 1px solid #e1e1e1 !important;
    color: #b7b7b7 !important;
    background: #f9f9f9 url('data:image/png;base64,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')  no-repeat center right;
  }

  .cp-td-button:active {
    border: 1px solid #003193 !important;
    color: #003193 !important;
  }

  .cp-td-button .cp-short-text {
    display: block;
    width: calc(100% - 16px);
    height: inherit;
    overflow: hidden;
    white-space: nowrap;
  }

  /*  */
  .cp-scroll {
    overflow-y: overlay;
    overflow-x: clip;
  }

  .cp-scroll--auto {
    overflow-y: auto;
  }

  .cp-scroll::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .cp-scroll::-webkit-scrollbar-track {
    background-color: #e3e3e3;
  }

  .cp-grid .cp-scroll::-webkit-scrollbar-track {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-scroll::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 10px;
    border: 5px solid #ffffff00;
  }

  .cp-scroll::-webkit-scrollbar-button {
    display: none;
  }

  .cp-parentnode > h2 {
    margin-top: 8px !important;
    margin-bottom: 0px !important;
  }

  .cp-unitbox {
    position: absolute;
    z-index: 10;
    min-width: 150px;
    border: 1px solid #b4b4b4;
    background-color: #ffffff;
    box-shadow: 0px 12px 26px 6px #a7a7a780;
    user-select: none;
  }

  .cp-unitbox.cp-popt {
    width:150px;
    border-radius: 10px;
  }

  .cp-unitbox > * {
    position: relative;
  }

  .cp-psel {
    text-align: left;
    line-height: 24px;
    cursor: default;
    height: 24px;
    padding: 0 20px 0 5px;
    border: solid 1px #cecece;
    font-size: 13px;
    letter-spacing: -1px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQ2NUMwQjRFRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQ2NUMwQjRGRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDY1QzBCNENGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDY1QzBCNERGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4h6VXxAAAATlBMVEWPj4/o6OiQkJDMzMzOzs7j4+Oamprk5OSSkpKOjo6NjY3Q0NDl5eXHx8fIyMjPz8/m5ubNzc2RkZHLy8vS0tLJycnV1dXn5+f////////PBEJmAAAAGnRSTlP/////////////////////////////////ABQiANoAAABISURBVHjaYpDEARiGlwQvJ7sECLBy8aFKSIgyCADFeRiEJdAkJJiZGCXEGQQlMCQkWDjEhPglsEhIcLOJSGBIDPvQxQQAAQYA98E2rkH8+7gAAAAASUVORK5CYII=) no-repeat right 50%;
    width: 100%;
    font-weight: 300;
    vertical-align: middle;
    font-family: 'Noto Sans KR', sans-serif;
    word-wrap: normal;
    text-transform: none;
    margin: 0;
  }

  .cp-psel:disabled {
    border: 1px solid #e1e1e1;
    color: #b7b7b7 !important;
    background: #f9f9f9 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0M3MDRDRjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0M3MDRERjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDQzcwNEFGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDQzcwNEJGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Bnl+bAAAAKlBMVEXPz8/k5OTOzs7t7e3u7u7s7Ozl5eXm5ubj4+PS0tLn5+fi4uL29vb///9dVj3DAAAADnRSTlP/////////////////AEXA3MgAAABESURBVHja3NDLAYAgEAPRsHwWdei/XfCoqw0wx7xbNH7SXnBZ5a5afwLd8tqzEi8gqVDWHoCmU40PwA8nwPbvxqYAAwAEZRw7sBHRUAAAAABJRU5ErkJggg==) no-repeat right 50% !important;
  }

  .cp-psel::placeholder {
    color: #000000;
  }

  .cp-psel:disabled::placeholder {
    color: #b7b7b7;
  }

  .cp-psel:focus {
    border-color: #0641b8 !important;
    outline: none;
  }

  .cp-popt--close {
    display: none;
  }

  .cp-popt .cp-ul {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-li-header {
    padding: 8px 13px 8px 11px;
  }

  .cp-li-header--condition {
    min-height: 30px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #cecece;
  }

  .cp-realfiltering .cp-li-header {
    background-color: #ffffff;
  }

  .cp-ul {
    max-height: 300px;
    text-align: left;
    font-weight: 400;
    font-size: 13px;
    text-align: left;
    user-select: none;
  }

  .cp-ul--hide {
    height: 1px;
    border-top: 1px solid #cecece;
    padding-right: 15px;
  }

  .cp-ul--hide .cp-li {
    height: inherit;
    color: #ffffff00;
  }

  .cp-ul--blank {
    background-color: #f6f6f6;
  }

  .cp-li {
    white-space: nowrap;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: #ffffff;
  }

  .cp-ul--plc .cp-li {
    padding: 0px 11px 0px 11px;
  }

  .cp-li > span {
    position: relative;
    left: 5px;
  }

  .cp-popt .cp-li:hover,
  .cp-ul--ctr:not(:hover) .cp-li--selected,
  .cp-ul--plc .cp-li--selected,
  .cp-grid .cp-ul:not(:hover) .cp-li--selected,
  .cp-ul--cond .cp-li:hover,
  .cp-ul--vals .cp-li:hover,
  .cp-ul--cond .cp-li--selected,
  .cp-ul--vals .cp-li--selected {
    background-color: #eaebf2 !important;
    color: #075bb9 !important;
  }

  .cp-li--dummy {
    pointer-events: none;
    height: 1px;
  }

  .cp-pchkbox--disabled {
    cursor: default;
    pointer-events: none;
  }

  .cp-pchkbox--disabled:before {
    background-position: 0 -54px !important;
  }

  .cp-pchkbox--hide {
    display: none !important;
  }

  .cp-pchkbox--selected:before {
    background-position: 0 -18px !important;
  }

  .cp-li--hide {
    display: none;
  }

  .multi-line-css {
    white-space: pre !important;
    text-align: center;
  }

  </style>
